import { useEffect, useState } from "react";
import { fetchMeterPayloadDetailsAsync } from "../actions/meters.actions";
import { useErrorHandler } from "./useErrorHandler";
import { MeterPayloadDetailsReturnType } from "../types";
import { useMeterStore } from "../store/meter.store";

export default function useMeterPayload() {
  const dailyCutoffRecordId = useMeterStore(
    (state) => state.dailyCutoffRecordId
  );
  const setDailyCutoffRecordId = useMeterStore(
    (state) => state.setDailyCutoffRecordId
  );

  const { handleError } = useErrorHandler();
  const { comeFromMeterSidebarSelector, setMeterSidebarSelector } =
    useMeterStore((state) => state);

  const [loading, setLoading] = useState(false);
  const [payloadDetails, setPayloadDetails] =
    useState<MeterPayloadDetailsReturnType | null>(null);

  const fetchPayloadDetails = async () => {
    setLoading(true);

    fetchMeterPayloadDetailsAsync(dailyCutoffRecordId || "")
      .then((data: any) => {
        setPayloadDetails(data?.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        handleError(error);
      });
  };

  const goBack = () => {
    setMeterSidebarSelector(comeFromMeterSidebarSelector);
  };

  useEffect(() => {
    if (dailyCutoffRecordId) {
      fetchPayloadDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dailyCutoffRecordId]);

  useEffect(() => {
    setDailyCutoffRecordId(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    loading,
    payloadDetails,
    goBack,
  };
}
